import React, { useState } from 'react';
import styles from './expandableText.module.scss';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import { Collapsible, CollapsibleContent, CollapsibleHeading, dlsWhiteBg } from '@americanexpress/dls-react';
import { trackClick } from 'src/hooks/useAdobeTags';
import { useLocation } from 'react-router';
import LiteralsService from 'src/services/literals/LiteralsService';

export interface ExpandableTextProps {
    title: string;
    body: string | JSX.Element;
    className?: string;
    onClick?: (isExpanded: boolean) => void;
    tagName?: { ShowDetails: string; HideDetails: string };
    collapsibleContentClassName?: string;
}

const ExpandableText = ({
    title,
    body,
    className,
    onClick,
    tagName,
    collapsibleContentClassName
}: ExpandableTextProps): JSX.Element => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const { pathname } = useLocation();
    const headingId: string = `collapsible-text-${title.split(' ').join('-')}`;
    return (
        <Collapsible
            className={`${styles.collapsible} ${className}`}
            onCollapsibleHeadingClick={() => {
                onClick?.(isExpanded);
                setIsExpanded(!isExpanded);
                trackClick(pathname, isExpanded ? tagName.HideDetails : tagName.ShowDetails);
            }}
        >
            <div className={`${DlsTypographyVariants.BODY_2} ${styles.collapsibleHeading}`}>
                <p>{title}</p>
                <span>
                    <CollapsibleHeading
                        id={headingId}
                        aria-label={LiteralsService.getLiteral(
                            isExpanded ? 'ExpandableText.hideDetails' : 'ExpandableText.showDetails'
                        )}
                    />
                </span>
            </div>
            <CollapsibleContent
                className={`${styles.collapsibleContent} ${collapsibleContentClassName}`}
                labelledBy={headingId}
                theme={dlsWhiteBg}
            >
                <p className={DlsTypographyVariants.BODY_1}>{body}</p>
            </CollapsibleContent>
        </Collapsible>
    );
};

export default ExpandableText;
